import React from "react";
import { Spin } from "antd";
import { ICourtCaseConnectionTypePresenter } from "../../presenter/CourtCaseConnectionTypePresenter";
import Page, { PageProps } from "../../../core/ui/pages/Page";
import CourtCaseConnectionTypeGrid from "../components/CourtCaseConnectionTypeGrid";

export interface Props extends PageProps {}

export interface State extends ICourtCaseConnectionTypePresenter {}

export default class CourtCaseConnectionTypePage extends React.Component<
  Props,
  State
> {
  private subscriptionId: number = 0;

  constructor(props: any) {
    super(props);
    this.state = { ...props };
  }

  componentDidMount() {
    this.subscriptionId = this.state.store.subscribe((result) => {
      return this.setState((prevState) => result);
    });
  }

  componentWillUnmount() {
    this.state.store.unsubscribe(this.subscriptionId);
  }

  render() {
    const {
      translate,
      courtCaseConnectionTypeList,
      createCourtCaseConnectionType,
      updateCourtCaseConnectionType
    } = this.state;

    return (
      <Page {...this.props} className={"content-wrapper"}>
        {
          <Spin spinning={this.state.loaders.courtCaseConnectionTypeLoader}>
            <CourtCaseConnectionTypeGrid
              translate={translate}
              courtCaseConnectionTypeList={courtCaseConnectionTypeList}
              createCourtCaseConnectionType={createCourtCaseConnectionType}
              referenceLoader={this.state.loaders.courtCaseConnectionTypeLoader}
              updateCourtCaseConnectionType={updateCourtCaseConnectionType}
            />
          </Spin>
        }
      </Page>
    );
  }
}
